import fireApp from '../fireConfig.js'
import moment from 'moment';


export function lastPosts(callback) {
    let component = this;

    fireApp.database().ref('blog/posts').orderByValue().limitToLast(2).once('value').then(function(snapshot){
        component.posts = [];

        snapshot.forEach(function(child) {
            var childData = child.val();
            
            childData.key = child.key;
            component.posts.push(childData);
            
        });
        callback(component.posts);
    })
}

export function getPostById (key, callback) {
    fireApp.database().ref('blog/posts/' + key).once('value').then(function(snapshot){
        var post = snapshot.val();
        post.id = snapshot.key;
        callback(post);
    })
}

//MANEJAR CORRECTAMENTE EL ERROR EN CASO DE QUE FALLE OBTENER EL LISTADO DE POSTS
export function getAll(callback) {
    
    fireApp.database().ref('blog/posts').orderByChild('timestamp').once('value').then(function(snapshot){
            let posts = [];

            snapshot.forEach(function(child) {
                var childData = child.val();
               
                childData.key = child.key;
                posts.push(childData);
                
            });

            callback(posts);
    })
}

export function eliminarPost(post) {
    let result = {
        mensajes: [],
        estado: false,
    }

    result.mensajes.push("No implementado");

    return result;
}

export function savePost(post) {

    let result = {
        mensajes: [],
        estado: false,
    }

    if (post.titulo == null) {
        result.mensajes.push('Ingrese un titulo por favor');
    }

    if (post.descripcionCorta == null) {
        result.mensajes.push('Ingrese una descripcion corta por favor');
    }

    if (post.descripcion == null) {
        result.mensajes.push('Ingrese una descripcion por favor');
    }

    if (result.mensajes.length > 0) return result;

    
    if (post.id == null) {

        var postsRef = fireApp.database().ref().child('blog/posts');
        postsRef.push(post);

        result.mensajes.push('Post agregado correctamente'); 
        result.estado = true;
    } else {
        fireApp.database().ref('blog/posts/' + post.id).set({
            fecha : post.fecha,
            timestamp : post.timestamp,
            titulo : post.titulo,
            descripcionCorta: post.descripcionCorta,
            descripcion: post.descripcion,
            fuentes: post.fuentes,
        });

        result.mensajes.push('Post actualizado correctamente'); 
        result.estado = true;
    }

    
    return result;
}


// WEBPACK FOOTER //
// ./E:/dev/repos/wpo_sitecontrol/src/services/blog/blog.service.js